import { AlertCircle } from "lucide-react";
import { ReportCard } from "./ReportCard";

interface ExecutiveSummaryProps {
  summary: string[];
  keyTakeaway: string;
  sentiment: "positive" | "neutral" | "negative";
  isEditing?: boolean;
  onUpdate?: (updates: { key_takeaway?: string; sentiment?: string; paragraphs?: string[] }) => void;
}

export function ExecutiveSummary({
  summary,
  keyTakeaway,
  sentiment,
  isEditing,
  onUpdate,
}: ExecutiveSummaryProps) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
      <div className="mb-6">
        <h2 className="text-3xl font-sans font-semibold text-[#1e3a5f] mb-2">Executive Summary</h2>
        <div className="h-1 w-20 bg-[#d4975c] rounded-full" />
      </div>

      <ReportCard className="p-4 sm:p-6 lg:p-8 border-l-4 border-slate-200 bg-white">
        <div className="flex gap-4">
          <div className="flex-1">
            <div className="mb-4">
              <div className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 mb-3">
                <AlertCircle className="w-4 h-4" />
                KEY TAKEAWAY
              </div>
              {isEditing ? (
                <textarea
                  className="w-full text-xl font-semibold text-slate-900 leading-relaxed bg-white border border-slate-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#d4975c]/50 resize-y"
                  value={keyTakeaway}
                  onChange={(e) => onUpdate?.({ key_takeaway: e.target.value })}
                  rows={2}
                />
              ) : (
                <p className="text-xl font-semibold text-slate-900 leading-relaxed">
                  {keyTakeaway}
                </p>
              )}
            </div>

            {isEditing && (
              <div className="mb-4">
                <label className="text-sm font-semibold text-slate-600 mb-1 block">SENTIMENT</label>
                <select
                  value={sentiment}
                  onChange={(e) => onUpdate?.({ sentiment: e.target.value })}
                  className="px-3 py-1.5 text-sm border border-slate-300 rounded-md bg-white text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#d4975c]/50"
                >
                  <option value="positive">Positive</option>
                  <option value="neutral">Neutral</option>
                  <option value="negative">Negative</option>
                </select>
              </div>
            )}

            <div className="h-px bg-slate-200 my-6" />

            <div className="space-y-4">
              {summary.map((paragraph, index) => (
                isEditing ? (
                  <textarea
                    key={index}
                    className="w-full text-slate-700 leading-relaxed bg-white border border-slate-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#d4975c]/50 resize-y"
                    value={paragraph}
                    onChange={(e) => {
                      const updated = [...summary];
                      updated[index] = e.target.value;
                      onUpdate?.({ paragraphs: updated });
                    }}
                    rows={3}
                  />
                ) : (
                  <p key={index} className="text-slate-700 leading-relaxed">
                    {paragraph}
                  </p>
                )
              ))}
            </div>

          </div>
        </div>
      </ReportCard>
    </div>
  );
}
